<template>
  <div class="d-flex flex-column h-100">
    <!-- Floating panel: Target + Year + Month + Legend -->
    <div
      class="pb-4 pt-3 px-3 rounded shadow text-center"
      style="position:absolute;bottom:50px;right:10px;z-index:1001;min-width:320px;background:#003252;"
    >
      <div class="d-flex align-items-center justify-content-center mb-2 gap-2">
        <select v-model="selectedTarget" class="form-select form-select-sm" style="max-width:220px">
          <option v-for="t in targets" :key="t" :value="t">{{ t }}</option>
        </select>
        <select v-model.number="selectedYear" class="form-select form-select-sm" style="width:110px">
          <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
        </select>
      </div>

      <VueSlider
        v-model="selectedMonth"
        :min="1"
        :max="12"
        :marks="monthMarksYear"
        :dot-size="14"
        :height="4"
        :tooltip-formatter="(v)=> monthShort[v]"
        class="text-light mb-4"
        :process-style="{ backgroundColor: '#00cbd5' }"
        :tooltip-style="{ backgroundColor: '#00cbd5', borderColor: '#00cbd5' }"
      />

      <small v-if="sliderData.length === 0" class="d-block mt-1 text-light">
        No months available for {{ selectedYear }} and target "{{ selectedTarget || '—' }}".
      </small>

      <hr style="color:white" class="m-0 mt-2" />
      <div id="legend-div"></div>
    </div>
    <!-- Chart modal -->
    <div v-if="showChart" class="chart-modal-backdrop" @click.self="closeChart">
      <div class="chart-modal">
        <div class="chart-modal-header">
          <div class="chart-title">
            {{ chartTitle || 'Time Series' }}
          </div>
          <button class="btn btn-sm btn-light" @click="closeChart">Close</button>
        </div>
        <div class="chartWrapper">
          <div class="chartAreaWrapper" ref="chartAreaWrap">
            <canvas ref="chartCanvas" aria-label="Time series chart" height="100%" width="1200"></canvas>
          </div>
          <canvas ref="chartAxisCanvas" aria-label="Y axis"></canvas>
        </div>


      </div>
    </div>
    <!-- Info modal -->
   <div v-if="showInfoModal" class="chart-modal-backdrop" @click.self="closeInfo">
    <div class="chart-modal-info">
      <div class="chart-modal-header">
        <div class="chart-title">Information</div>
        <button class="btn btn-sm btn-light" @click="closeInfo">Close</button>
      </div>
      <div class="p-3">
        <div class="accordion" id="accordionExample">

          <!-- Nord Accordion -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" @click="loadPlot">
                Nord
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <nav>
                  <div class="nav nav-tabs" role="tablist">
                    <button v-for="(item,index,i) in info_json['nord']" :key="item+'info_tab'" class="nav-link" :class="{active: i === 0}" data-bs-toggle="tab" :data-bs-target="'#'+index.replaceAll(' ','_')" type="button" @click="loadPlot">{{index}}</button>
                  </div>
                </nav>
                <div class="tab-content" >
                  <div v-for="(item,index,i) in info_json['nord']" :key="index.replaceAll(' ','_')" class="tab-pane fade" :class="{show: i === 0, active: i === 0}" :id="index.replaceAll(' ','_')" role="tabpanel" style="max-height:65vh;overflow-y: auto;">
                    <h4 v-if="info_json['nord'][index][0].png" class="mt-4">2025 Validation</h4> 
                  
                   <div v-if="info_json['nord'][index][0].png"  class="text-center"><img :src="info_json['nord'][index][0].png"  /></div>
                   
                    <h4 class="mt-4">Local interpretation plots</h4>
                    <p style="font-size:12px">*sorted by importance (highest → lowest)</p>
                    <div class="mt-3" v-for="(it,number) in info_json['nord'][index]" :key="number+'local'">
                      
                      <a :href="info_json['nord'][index][number].html" target="_blank" class="d-flex align-items-center" style="text-decoration: none;color:#003b92" v-if="info_json['nord'][index][number].html">
                       
                          <i class="fa-solid fa-chart-column pr-3"></i>
                         <p class="m-0 px-2">
                          {{info_json['nord'][index][number].title}}
                        </p> 
                      </a>
                      <!--<PlotNavigator v-if="showplot" :plots="info_json['nord'][index]" />-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Extreme Nord Accordion -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" @click="loadPlot">
                Extreme Nord
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <nav>
                  <div class="nav nav-tabs" role="tablist">
                    <button v-for="(item,index,i) in info_json['extreme nord']" :key="item+'info_tab'" class="nav-link" :class="{active: i === 0}" data-bs-toggle="tab" :data-bs-target="'#ext-'+index.replaceAll(' ','_')" type="button" @click="loadPlot">{{index}}</button>
                  </div>
                </nav>
                <div class="tab-content">
                  <div v-for="(item,index,i) in info_json['extreme nord']" :key="index" class="tab-pane fade" :class="{show: i === 0, active: i === 0}" :id="'ext-'+index.replaceAll(' ','_')" role="tabpanel" style="max-height:65vh;overflow-y: auto;">
                    <h4 v-if="info_json['extreme nord'][index][0].png" class="mt-4">2025 Validation</h4> 
                    <div v-if="info_json['extreme nord'][index][0].png" class="text-center"><img :src="info_json['extreme nord'][index][0].png"  /></div>
                    <h4 class="mt-4">Local interpretation plots</h4>
                    <p style="font-size:12px">*sorted by importance (highest → lowest)</p>
                    <div class="mt-3" v-for="(it,number) in info_json['extreme nord'][index]" :key="number+'extreme nord'" >
                      
                      <a :href="info_json['extreme nord'][index][number].html" target="_blank" class="d-flex align-items-center" style="text-decoration: none;color:#003b92" v-if="info_json['extreme nord'][index][number].html">
                       
                          <i class="fa-solid fa-chart-column pr-3"></i>
                         <p class="m-0 px-2">
                          {{info_json['extreme nord'][index][number].title}}
                        </p> 
                      </a>
                      <!--<PlotNavigator v-if="showplot" :plots="info_json['nord'][index]" />-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  
    <!-- Map wrapper with loader overlay -->
    <div class="map-wrap position-relative flex-grow-1">
      <div id="map" style="min-height:100vh;"></div>

      <!-- Loader overlay -->
      <div v-if="mapLoading" class="map-loader-overlay">
        <div class="map-spinner"></div>
        <div class="map-loader-text">Loading polygons…</div>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger m-3 p-2">{{ error }}</div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch, toRaw, markRaw,nextTick } from 'vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

/* Leaflet core */
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

/* IMPORTANT: expose L globally so UMD plugins can find it */
if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-undef
  window.L = L
}

/* ── REQUIRED for leaflet.measurecontrol ──────────────────────────
   1) Install:  npm i leaflet-draw leaflet.measurecontrol
   2) Import Leaflet.Draw BEFORE measurecontrol
------------------------------------------------------------------*/
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'

/* The measure control you asked for */
import 'leaflet.measurecontrol'
//import 'leaflet.measurecontrol/leaflet.measurecontrol.css'

import api from '@/api/axios'
import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

import Chart from 'chart.js/auto' // npm i chart.js
import legend_json from '@/assets/legend.json' // legend HTML snippets
import info_json from '@/assets/info.json' // legend HTML snippets
//import VirtualScroller from '@/components/VirtualScroller.vue'
//import PlotNavigator from '@/components/PlotNavigator.vue';
// ---- Chart state ----
const showChart = ref(false)
const chartCanvas = ref(null)
let chartInstance = null
const chartTitle = ref('')

// Close modal & destroy chart
function closeChart() {
  showChart.value = false
  if (chartInstance) {
    chartInstance.destroy()
    chartInstance = null
  }
}

function closeInfo() {
  showInfoModal.value = false
}

/** ===== Map state ===== */
const map = ref(null)
let baseTiles = null

let polygonsLayer = null
let canvasRenderer = null
let boundariesLayer = null
// --- Layers & controls additions ---

let baseOSM = null
let polygonsGroup = null
let boundariesGroup = null
let layersControl = null
let logoutControl = null
let infoControl = null
let logosControl = null
let bigImageControl = null
// Coordinates control state
let coordsControl = null
let coordsMoveHandler = null
// Measure control state
let measureControl = null

const mapLoading = ref(false)

/** ===== UI state ===== */
const gid0 = ref('extreme nord')
const simplify = ref(0.001)
const loading = ref(false)
const error = ref('')
const showInfoModal = ref(false)

/** ===== Dates/targets from API ===== */
const years = ref([])
const monthsByYear = ref({})
const monthsByYearTarget = ref({})
const latestByTarget = ref({})
const targets = ref([])
const showplot = ref(false)
const selectedTarget = ref('')
const selectedYear = ref(new Date().getFullYear())
const selectedMonth = ref(new Date().getMonth() + 1)

// put these near the top of <script setup>, with the other helpers
// --- Boundaries hover/selection styles ---
const BOUNDARY_STYLE_DEFAULT  = { weight: 1, opacity: 1, color: 'blue',   fillOpacity: 0.1 }
const BOUNDARY_STYLE_HOVER    = { weight: 2, opacity: 1, color: '#00cbd5', fillOpacity: 0.25 }
// keep selected readable but NOT hover-highlighted
const BOUNDARY_STYLE_SELECTED = { weight: 2, opacity: 1, color: 'blue',    fillOpacity: 0.15 }

const normName = (s) => String(s || '').trim().toLowerCase()
const isSelectedFeature = (f) => normName(f?.properties?.name) === normName(gid0.value)


// Keep the *current* bins/palette used on the map (so chart matches legend exactly)
const currentBins = ref(null)      // array from buildZeroBasedIntegerBins(...)
const currentPalette = ref(null)   // array from pickPalette(...)

// Which legend class index is selected (null = none)
const selectedLegendClass = ref(null)

const chartAreaWrap = ref(null)
const chartAxisCanvas = ref(null)

function sizeScrollableChartCanvases(labels){
  const wrap = chartAreaWrap.value
  const main = chartCanvas.value
  const axis = chartAxisCanvas.value
  if (!wrap || !main || !axis) return

  // Tune these to taste
  const PX_PER_BAR = 40
  const MIN_W = wrap.clientWidth
  const MAIN_W = Math.max(MIN_W, labels.length * PX_PER_BAR + 80) +200// +padding
  const MAIN_H = Math.max(320, wrap.clientHeight - 8)

  // Set explicit bitmap sizes so Chart.js uses them
  main.width  = MAIN_W
  main.height = MAIN_H

  // Axis width will be set after Chart.js renders (we copy from main)
  axis.height = MAIN_H
}

/** Copy the left gutter (y-axis + labels) from the main chart into the axis canvas */
function copyYAxisFromMain(chart){
  const main = chart?.canvas
  const axis = chartAxisCanvas.value
  if (!main || !axis) return
  const dpr = Math.max(1, Math.min(3, window.devicePixelRatio || 1))
  const ca = chart.chartArea

  const copyWidth  = Math.max(0, Math.ceil(ca.left))         // gutter (CSS px)
  const copyHeight = Math.ceil(ca.bottom)                    // CSS px

  // CSS size (what user sees)
  axis.style.width  = `${copyWidth}px`
  axis.style.height = `${copyHeight}px`

  // bitmap size (device px)
  axis.width  = Math.round(copyWidth  * dpr)
  axis.height = Math.round(copyHeight * dpr)

  const axisCtx = axis.getContext('2d')
  axisCtx.clearRect(0, 0, axis.width, axis.height)
  // draw using device px source/dest
  axisCtx.drawImage(
    main,
    0, 0, Math.round(copyWidth * dpr), Math.round(copyHeight * dpr),
    0, 0, Math.round(copyWidth * dpr), Math.round(copyHeight * dpr)
  )
}

function loadPlot(){
  showplot.value=false
  setTimeout(()=>{
    showplot.value=true
  },50)
}


/** Given a numeric value, return the class index per currentBins */
function classIndexForValue(v, bins){
  if (!Number.isFinite(v) || !bins?.length) return -1
  for (let i = 0; i < bins.length; i++) {
    const b = bins[i]
    if (i < bins.length - 1) {
      if (v >= b.min && v < b.max) return i
    } else {
      if (v >= b.min && v <= b.max) return i
    }
  }
  return -1
}

/** Build per-bar colors, optionally dim non-selected classes */
function buildBarColors(values, bins, palette, selectedIdx){
  if (!bins || !palette) return values.map(()=> '#cccccc')
  return values.map(v => {
    const idx = classIndexForValue(v, bins)
    const base = palette[idx >= 0 ? idx : palette.length - 1] || '#cccccc'
    if (selectedIdx == null) {
      // no legend selection → normal color with alpha
      return base.startsWith('rgb(')
        ? base.replace('rgb(', 'rgba(').replace(')', ', 0.85)')
        : base + 'D9' // add alpha for hex if desired
    }
    // if selected class set → keep selected vivid, dim others
    const isSelected = idx === selectedIdx
    if (base.startsWith('rgb(')) {
      return isSelected
        ? base.replace('rgb(', 'rgba(').replace(')', ', 0.95)')
        : 'rgba(180,180,180,0.35)'
    }
    return isSelected ? base : '#b4b4b459'
  })
}


/** Walk through boundaries and restyle them based on selection */
function updateBoundaryStyles () {
  const container = toRaw(boundariesGroup) || toRaw(boundariesLayer)
  if (!container) return

  const applyTo = (lyr) => {
    if (lyr?.feature) {
      const style = isSelectedFeature(lyr.feature) ? BOUNDARY_STYLE_SELECTED : BOUNDARY_STYLE_DEFAULT
      lyr.setStyle?.(style)
    } else if (typeof lyr?.eachLayer === 'function') {
      lyr.eachLayer(applyTo)
    }
  }

  if (typeof container.eachLayer === 'function') {
    container.eachLayer(applyTo)
  } else {
    applyTo(container)
  }
}


const sliderData = computed(() => {
  const yKey = String(selectedYear.value)
  const byTarget = monthsByYearTarget.value?.[yKey]?.[selectedTarget.value] || null
  const base = monthsByYear.value?.[yKey] || []
  const arr = byTarget && byTarget.length ? byTarget : base
  return (arr || []).filter(m => m >= 1 && m <= 12).sort((a, b) => a - b)
})

const monthShort = {1:'Jan',2:'Feb',3:'Mar',4:'Apr',5:'May',6:'Jun',7:'Jul',8:'Aug',9:'Sep',10:'Oct',11:'Nov',12:'Dec'}
const monthMarksYear = computed(() =>
  Object.fromEntries(sliderData.value.map(m => [m, monthShort[m]]))
)

const dt_reference = computed(() => {
  const y = selectedYear.value
  const m = String(selectedMonth.value).padStart(2, '0')
  return `${y}-${m}`
})

/** ===== Auth / nav ===== */
const router = useRouter()
const { logout } = useAuth()
function logoutAndGo() { logout(); router.push('/login') }

/** ===== Helpers ===== */
function escapeHtml(s) {
  return String(s).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;')
}
function featureFilter(feature) {
  if (!feature || !feature.geometry) return false
  const g = feature.geometry
  if (g.type === 'Polygon' || g.type === 'MultiPolygon') {
    return Array.isArray(g.coordinates) && g.coordinates.length > 0
  }
  return true
}
function safeRemove(layer) {
  const m = toRaw(map.value)
  const l = toRaw(layer)
  if (m && l && m.hasLayer(l)) l.removeFrom(m)
}
function safeAdd(layer) {
  const m = toRaw(map.value)
  const l = toRaw(layer)
  if (m && l) l.addTo(m)
}
function fitIfGeometry(layer) {
  const m = toRaw(map.value)
  const l = toRaw(layer)
  if (!m || !l || !l.getBounds) return
  const b = l.getBounds()
  if (b && b.isValid()) requestAnimationFrame(() => m && m.fitBounds(b, { padding:[20,20] }))
}

/** ===== Coordinates control ===== */
function prettyNum(n, digits = 5) {
  return Math.abs(n) >= 1000 ? n.toFixed(1) : n.toFixed(digits)
}
function projectToEPSG3857(latlng) {
  const pt = L.CRS.EPSG3857.project(latlng)
  return { x: pt.x, y: pt.y }
}
function buildCoordsControl() {
  const ctl = L.control({ position: 'bottomleft' })
  ctl.onAdd = () => {
    const container = L.DomUtil.create('div', 'leaflet-control coords-control shadow')
    container.innerHTML = `
      <div class="coords-inner">
        <div class="coords-row">
          <label class="coords-label">Projection</label>
          <select class="form-select form-select-sm coords-select">
            <option value="4326">WGS84 (EPSG:4326)</option>
            <option value="3857">Web Mercator (EPSG:3857)</option>
          </select>
        </div>
        <div class="coords-values" aria-live="polite">
          <div><span class="coords-key">X:</span> <span class="coords-x">—</span></div>
          <div><span class="coords-key">Y:</span> <span class="coords-y">—</span></div>
        </div>
      </div>
    `
    L.DomEvent.disableClickPropagation(container)
    L.DomEvent.disableScrollPropagation(container)

    const selectEl = container.querySelector('.coords-select')
    const xEl = container.querySelector('.coords-x')
    const yEl = container.querySelector('.coords-y')

    const update = (latlng) => {
      if (!latlng) { xEl.textContent = '—'; yEl.textContent = '—'; return }
      const mode = selectEl.value
      if (mode === '3857') {
        const { x, y } = projectToEPSG3857(latlng)
        xEl.textContent = prettyNum(x, 1)
        yEl.textContent = prettyNum(y, 1)
      } else {
        xEl.textContent = prettyNum(latlng.lng)
        yEl.textContent = prettyNum(latlng.lat)
      }
    }

    coordsMoveHandler = (e) => update(e.latlng)

    const m = toRaw(map.value)
    if (m) {
      m.on('mousemove', coordsMoveHandler)
      m.on('mouseout', () => update(null))
      update(m.getCenter())
    }

    selectEl.addEventListener('change', () => {
      const m2 = toRaw(map.value)
      if (m2) update(m2.getCenter())
    })

    return container
  }
  return ctl
}

/** ===== Coloring helpers ===== */
const PALETTES = {
  7:  ['#2b83ba','#6bb0af','#d5eeb2','#ffffbf','#fdae61','#ea643f','#d7191c'],
  8:  ['#2b83ba','#6bb0af','#abdda4','#d5eeb2','#fed790','#fdae61','#ea643f','#d7191c'],
  9:  ['#2b83ba','#6bb0af','#abdda4','#d5eeb2','#ffffbf','#fed790','#fdae61','#ea643f','#d7191c'],
  10: ['#f7fbff','#deebf7','#c6dbef','#9ecae1','#6baed6','#4292c6','#2171b5','#08519c','#08306b','#041c3c']
}
function pickPalette(n){
  if (PALETTES[n]) return PALETTES[n]
  return Array.from({length:n}, (_,i)=>{
    const t = n===1 ? 0 : i/(n-1)
    const r = Math.round(255*(1-t))
    const g = Math.round(245*(1-t*0.8))
    const b = Math.round(235*(1-t*0.9))
    return `rgb(${r},${g},${b})`
  })
}
function buildZeroBasedIntegerBins(maxInt){
  const bins = []
  for (let i=0; i<maxInt; i++){
    bins.push({ min:i, max:i+1, label: String(i) })
  }
  if (bins.length === 0) bins.push({ min:0, max:1, label:'0' })
  return bins
}
function colorFromBins(value, bins, palette){
  if (!Number.isFinite(value)) return '#ccc'
  for (let i=0; i<bins.length; i++){
    const {min,max} = bins[i]
    if (i < bins.length-1) {
      if (value >= min && value < max) return palette[i]
    } else {
      if (value >= min && value <= max) return palette[i]
    }
  }
  if (value < bins[0].min) return palette[0]
  return palette[palette.length-1]
}

const target_legend_table=legend_json

function csvEscape(value) {
  if (value == null) return ''
  const str = String(value)
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

async function downloadSelectedTargetCsv() {
  try {
    const params = {
      gid0: gid0.value,
      dt_reference: dt_reference.value
    }

    if (selectedTarget.value) params.target = selectedTarget.value
    if (simplify.value && Number(simplify.value) > 0) params.simplify = simplify.value

    const { data } = await api.get('api/modeling-data/', { params })

    const features = data?.features || []
    if (!features.length) {
      error.value = 'No data available to export'
      return
    }

    const headers = [
      'gid0',
      'gid1',
      'gid2',
      'gid3',
      'target',
      'dt_reference',
      'prediction',
      'actual'
    ]

    const rows = features.map((f) => {
      const p = f?.properties || {}
      return [
        p.gid0 ?? '',
        p.gid1 ?? '',
        p.gid2 ?? '',
        p.gid3 ?? '',
        p.target ?? '',
        p.dt_reference ?? '',
        p.prediction ?? '',
        p.actual ?? ''
      ]
    })

    const csv = [
      headers.map(csvEscape).join(','),
      ...rows.map(row => row.map(csvEscape).join(','))
    ].join('\n')

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${String(selectedTarget.value || 'modeling_data')
      .replace(/[^\w.-]+/g, '_')}_${gid0.value}_${dt_reference.value}.csv`

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.error('CSV download failed:', err)
    error.value = err?.response?.data?.detail || err.message || 'Failed to download CSV'
  }
}

/** ===== Legend ===== */
function addOrUpdateLegendClasses(classes, title='Prediction (classes)',dt_reference){
  const host = document.getElementById('legend-div')
  if (!host) return

  host.innerHTML = `
    <div class="text-light" style="min-width:140px;background:#003252;font-size:12px;">
      <div class="legend-header">
        <div class="legend-title">${escapeHtml(title)}</div>
        <div class="legend-help" tabindex="0" aria-label="Class ranges help" title="Class ranges">
          !
          <div class="legend-tooltip" role="tooltip" aria-hidden="true">
            <div class="legend-tooltip-inner">
              ${target_legend_table[(selectedTarget.value+' '+gid0.value).replaceAll(' ','_').toLowerCase()] || ''}
            </div>
          </div>
        </div>
      </div>

     

      <div id="legend-classes" class="d-flex justify-content-center flex-wrap" role="listbox" aria-label="Class filter"></div>
       <div class="text-center mt-2">
        <a href="#" id="legend-download-csv" class="legend-download-link">
          <i class="fa-solid fa-download"></i> Download CSV (${escapeHtml(selectedTarget.value || '')} – ${escapeHtml(dt_reference.value)})
        </a>
      </div>
    </div>
  `

  const el = host.querySelector('#legend-classes')
  const downloadLink = host.querySelector('#legend-download-csv')
  if (!el) return

  el.innerHTML = (classes || []).map((c,i)=>`
    <button
      type="button"
      class="legend-swatch"
      role="option"
      aria-selected="false"
      data-index="${i}"
      title="Class ${escapeHtml(String(c.label ?? ''))}"
      style="
        width:28px;height:21px;margin:2px;border:1px solid rgba(0,0,0,.25);
        background:${c.color};color:black;
        text-shadow:-1px -1px 0 white,1px -1px 0 white,-1px 1px 0 white,1px 1px 0 white;
        cursor:pointer;border-radius:3px;
      "
    >
      ${escapeHtml(String(c.label ?? ''))}
    </button>
  `).join('')

  downloadLink?.addEventListener('click', async (e) => {
    e.preventDefault()
    await downloadSelectedTargetCsv()
  })

  el.addEventListener('click', (e) => {
    const btn = e.target.closest('.legend-swatch')
    if (!btn) return
    const idx = Number(btn.dataset.index)
    selectedLegendClass.value = (selectedLegendClass.value === idx) ? null : idx
    updateLegendSelectionUI()
    recolorChartFromLegend()
  })

  function updateLegendSelectionUI(){
    const buttons = el.querySelectorAll('.legend-swatch')
    buttons.forEach((b) => {
      const i = Number(b.dataset.index)
      const selected = (selectedLegendClass.value === i)
      b.setAttribute('aria-selected', selected ? 'true' : 'false')
      b.style.outline = selected ? '2px solid #fff' : 'none'
      b.style.boxShadow = selected ? '0 0 0 2px rgba(0,203,213,.8) inset' : 'none'
    })
  }

  updateLegendSelectionUI()
}

/** ===== Boundaries ===== */
function handleBoundaryClick(props){
  const name = String(props?.name || '').trim()
  if (!name) return
  gid0.value = name
  loadPolygons()
  updateBoundaryStyles() // ← restyle boundaries to reflect new selection
}

async function loadBoundaries(){
  const params = {}
  if (simplify.value && Number(simplify.value) > 0) params.simplify = simplify.value
  const { data } = await api.get('api/boundaries/', { params })

  const next = markRaw(L.geoJSON(data, {
    renderer: canvasRenderer,
    filter: featureFilter,
    // initial style honors current selection
    style: (f) => (isSelectedFeature(f) ? BOUNDARY_STYLE_SELECTED : BOUNDARY_STYLE_DEFAULT),
    onEachFeature: (f, layer) => {
      const props = f?.properties || {}

      layer.on('mouseover', () => {
        if (layer._path) layer._path.style.cursor = 'pointer'
        // 🚫 do NOT hover-highlight if this feature is the selected one
        if (!isSelectedFeature(f)) {
          layer.setStyle(BOUNDARY_STYLE_HOVER)
          layer.bringToFront?.()
        }
      })

      layer.on('mouseout', () => {
        // revert to the appropriate (selected or default) style
        layer.setStyle(isSelectedFeature(f) ? BOUNDARY_STYLE_SELECTED : BOUNDARY_STYLE_DEFAULT)
      })

      layer.on('click', () => handleBoundaryClick(props))
      layer.bindPopup(`<b>name:</b> ${escapeHtml(props.name ?? '')}`)
    }
  }))

  if (boundariesGroup) {
    boundariesGroup.clearLayers()
    boundariesGroup.addLayer(next)
  } else {
    safeRemove(boundariesLayer)
    boundariesLayer = next
    safeAdd(boundariesLayer)
  }
}

function capitalize(s) {
  if (!s) return ''
  s = String(s)
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

async function makeAchart(props){
  try {
    const params = { polygon_id: props.polygon_id, target: selectedTarget.value }
    const { data } = await api.get('api/modeling-data/polygon-id/', { params })
    console.log('Data for chart:', data)
    // Normalize to array of records
    let records = Array.isArray(data) ? data
      : Array.isArray(data?.timeseries) ? data.timeseries
      : Array.isArray(data?.data) ? data.data
      : (Array.isArray(data?.rows) ? data.rows : [])

    if (!records.length) {
      console.warn('No records to chart')
      return
    }

    const dateKey = ['dt_reference','date','month','time','timestamp','period'].find(k => k in records[0]) || 'dt_reference'
    const labels = records.map(r => String(r[dateKey] ?? ''))
    const values  = records.map(r => {
      const v = r?.prediction
      return (typeof v === 'number') ? v : (v != null && !isNaN(+v) ? +v : null)
    })
    
    if (!values.some(v => typeof v === 'number')) {
      console.warn('No numeric prediction values to chart')
      return
    }

    const actualValues = records.map(r => {
      const v = r?.actual
      return (typeof v === 'number') ? v : (v != null && !isNaN(+v) ? +v : null)
    })

    // Use the SAME legend as the map if available; otherwise fall back
    let bins = currentBins.value
    let palette = currentPalette.value
    if (!bins || !palette) {
      const finiteVals = values.filter(v => typeof v === 'number')
      const maxVal = finiteVals.length ? Math.max(...finiteVals) : 1
      const maxClass = Math.max(1, Math.ceil(maxVal)) + 1
      bins = buildZeroBasedIntegerBins(maxClass)
      palette = pickPalette(bins.length)
      currentBins.value = bins
      currentPalette.value = palette
    }

    let lastColumn = Object.values(bins).at(-1);
    lastColumn=lastColumn.min
    console.log(lastColumn)

    const bgColors = buildBarColors(values, bins, palette, selectedLegendClass.value)
    chartTitle.value = `${capitalize(props?.gid3) || props?.gid0 || 'Polygon'} — ${selectedTarget.value} (prediction)`
    showChart.value = true
    await nextTick()

    // 1) Make the main canvas wide enough so it scrolls horizontally
    sizeScrollableChartCanvases(labels)

    if (chartInstance) { chartInstance.destroy(); chartInstance = null }
    const ctx = chartCanvas.value.getContext('2d')

    chartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
       datasets: [
          {
            label: 'prediction',
            data: values,
            backgroundColor: bgColors,
            borderColor: bgColors.map(c => c.replace('0.85','1.0').replace('0.95','1.0')),
            borderWidth: 1,
            barPercentage: 0.9,
            categoryPercentage: 0.8
          },
          {
            label: 'actual',
            data: actualValues,
            backgroundColor: 'rgba(169, 169, 169, 0.7)',   // 🔴 static color
            borderColor: 'rgba(169, 169, 169, 1)',
            borderWidth: 1,
            barPercentage: 0.9,
            categoryPercentage: 0.8
          }
        ]
      },
      options: {
        // IMPORTANT: let canvas size drive layout so scroll works
        responsive: false,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { display: true, position: 'top' },
          tooltip: {
            callbacks: {
              
              label: (ctx) => {
                const v = ctx.parsed.y
                const label = ctx.dataset.label

                // 👉 ACTUAL dataset
                if (label === 'actual') {
                  if (v === null || v === 0 || isNaN(v)) {
                    return 'actual: -'
                  }
                  return `actual: ${v}`
                }

                // 👉 PREDICTION dataset
                const idx = classIndexForValue(v, currentBins.value || [])
                const cls = idx < 0 ? '—' : idx
                return `prediction: ${v} (class: ${cls})`
              }
            }
          }
        },
        scales: {
          x: { grid: { display: false }, ticks: { maxRotation: 0, autoSkip: false, color: 'white' },stacked: false },
          y: { max: lastColumn,beginAtZero: true, ticks: { precision: 0, color: 'white' }, grid: { color: 'rgba(255,255,255,0.5)' } }
        },
        datasets: {
          bar: {
            minBarLength: 5 // 👈 pixels
          }
        },
        animation: {
          // After Chart.js draws axes and bars, copy the left gutter to the fixed canvas
          onComplete: () => copyYAxisFromMain(chartInstance)
        }
      }
    })

    // In case you update data/size later, you can re-copy the axis:
    copyYAxisFromMain(chartInstance)


  } catch (err) {
    console.error('makeAchart error:', err)
  }
}

// place near top-level helpers (once)
const _legendRangeCache = {}

function legendKeyForCurrent(target, g0) {
  return String((target + ' ' + g0).replaceAll(' ', '_')).toLowerCase()
}

/** Parse legend_html (from target_legend_table) into array of range strings.
 *  Returns ['0','1–5','6–15', ...] or null if nothing found.
 */
function parseRangesFromLegendHtml(legendHtml) {
  if (!legendHtml) return null
  try {
    // cache check handled by caller
    const tmp = document.createElement('div')
    tmp.innerHTML = legendHtml
    // prefer tbody rows, fall back to any table rows
    const rows = tmp.querySelectorAll('table .legend-table tbody tr')
    const useRows = rows.length ? rows : tmp.querySelectorAll('table tr')
    if (!useRows.length) return null
    const ranges = []
    useRows.forEach((r) => {
      const tds = r.querySelectorAll('td')
      // assume second column is range (td[1])
      if (tds.length >= 2) {
        ranges.push(tds[1].textContent.trim())
      } else if (tds.length === 1) {
        ranges.push(tds[0].textContent.trim())
      }
    })
    return ranges.length ? ranges : null
  } catch (err) {
    console.warn('parseRangesFromLegendHtml error', err)
    return null
  }
}

/** Return ranges array for the current selectedTarget + gid0 combination.
 *  Caches results in _legendRangeCache.
 */
function getLegendRangesFor(target, g0) {
  const key = legendKeyForCurrent(target, g0)
  if (key in _legendRangeCache) return _legendRangeCache[key]  // may be null
  const html = target_legend_table[key]
  const parsed = parseRangesFromLegendHtml(html)
  _legendRangeCache[key] = parsed || null
  return parsed || null
}
function capitalizeFirstLetter(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/** ===== Polygons ===== */
async function loadPolygons(){
  mapLoading.value = true            // <-- show overlay
  loading.value = true
  error.value = ''
  try {
    const params = { gid0: gid0.value, dt_reference: dt_reference.value }
    if (selectedTarget.value) params.target = selectedTarget.value
    if (simplify.value && Number(simplify.value) > 0) params.simplify = simplify.value

    const { data } = await api.get('api/modeling-data/', { params })
    console.log('Polygon data loaded:', data)
    const feats = data?.features ?? []
    const values = feats.map(f => Number(f?.properties?.classes_range)).filter(Number.isFinite)
    ////console.log(values)
    const maxVal = values.length ? Math.max(...values) : 1
    const maxClass = Math.max(1, Math.ceil(maxVal)) + 1

    const bins = buildZeroBasedIntegerBins(maxClass)
    const palette = pickPalette(bins.length)
    currentBins.value = bins
    currentPalette.value = palette

    const next = markRaw(L.geoJSON(data, {
      renderer: canvasRenderer,
      filter: featureFilter,
      smoothFactor: 1.2,
      noClip: true,
      bubblingMouseEvents: false,
      style: (f) => {
        const v = Number(f?.properties?.prediction)
        return {
          color: '#1d3557',
          weight: 0.8,
          opacity: 1,
          fillOpacity: 0.75,
          fillColor: colorFromBins(v, bins, palette)
        }
      },
      onEachFeature: (f, layer) => {
        layer.on('click', () => {
          const p = f.properties || {}

          // compute prediction number and class index (falls back safely)
          const predRaw = p.prediction
          const predNum = (predRaw != null && !isNaN(+predRaw)) ? +predRaw : null
          const predNumberText = Number.isFinite(predNum) ? predNum.toLocaleString() : '-'

          // get current legend ranges for the map (uses selectedTarget + gid0)
          const legendRanges = getLegendRangesFor(selectedTarget.value || '', gid0.value || p.gid0 || '')
          // find class index - prefer using currentBins if available; fallback to p.classes_range if set
          let classIdx = -1
          if (currentBins.value && Number.isFinite(predNum)) {
            classIdx = classIndexForValue(predNum, currentBins.value)
          } else if (Number.isFinite(+p.classes_range)) {
            classIdx = +p.classes_range
          }

          const rangeText = (Array.isArray(legendRanges) && classIdx >= 0 && classIdx < legendRanges.length)
            ? legendRanges[classIdx]
            : (p.classes_range != null ? String(p.classes_range) : '—')

          const predictionDisplay = Number.isFinite(predNum) ? `${predNumberText} (${rangeText} cases)` : '-'
          console.log('Clicked polygon properties:', p)
          // build DOM content so we can attach a proper event listener
          const container = document.createElement('div')
          container.style.minWidth = '240px'
          container.innerHTML = `
            <div class="mt-2"><b>Prediction Variable:</b> ${escapeHtml(selectedTarget.value || p.target || '')}</div>
            <div class="mt-2"><b>Date of prediction:</b> ${escapeHtml(p.dt_prediction)}</div>
            <div class="mt-2"><b>Date of reference:</b> ${escapeHtml(dt_reference.value)}</div>
            <div class="mt-2"><b>Region:</b> ${escapeHtml(capitalizeFirstLetter(p.gid0 ?? ''))}</div>
            <div class="mt-2"><b>District:</b> ${escapeHtml(capitalizeFirstLetter(p.gid2 ?? ''))}</div>
            <div class="mt-2"><b>Area:</b> ${escapeHtml(capitalizeFirstLetter(p.gid3 ?? ''))}</div>
            <div class="mt-2"><b>Predicted class-range:</b> ${escapeHtml(predictionDisplay)}</div>
           
            <div class="d-grid" style="margin-top:6px"><button class="btn history-btn btn-primary"><i class="fa-solid fa-chart-column"></i> History</button></div>
          `
          /* <hr style="margin:6px 0"/>
            <!--<pre style="margin:0;white-space:pre-wrap">${escapeHtml(JSON.stringify(p, null, 2))}</pre>--> */
          // attach click handler that closes over `p`
          const btn = container.querySelector('.history-btn')
          if (btn) {
            btn.addEventListener('click', (ev) => {
              ev.stopPropagation() // prevent popup/feature click fallout
              makeAchart(p)
            })
          }

          // bind the DOM element as popup content
          layer.bindPopup(container).openPopup()
        })
      }

    }))

    if (polygonsGroup) {
      polygonsGroup.clearLayers()
      polygonsGroup.addLayer(next)
    } else {
      safeRemove(polygonsLayer)
      polygonsLayer = next
      safeAdd(polygonsLayer)
    }
    fitIfGeometry(next)
    ////console.log(bins)
    const legendClasses = bins.map((b,i)=>({ label: b.label, color: palette[i] }))
    addOrUpdateLegendClasses(legendClasses, 'Prediction (classes)',dt_reference)
  } catch (e) {
    error.value = e?.response?.data?.detail || e.message || 'Failed to load polygons'
  } finally {
    loading.value = false
    mapLoading.value = false        // <-- hide overlay
  }
}


/** ===== Fetch available dates/targets ===== */
async function fetchAvailableDates(){
  try{
    const { data } = await api.get('api/modeling-data/dates/')
    years.value = (data?.years || []).sort((a,b)=>a-b)
    monthsByYear.value = data?.months_by_year || {}
    monthsByYearTarget.value = data?.months_by_year_target || {}
    latestByTarget.value = data?.latest_by_target || {}
    //targets.value = (data?.targets || []).filter(Boolean)

    targets.value = (data?.targets || [])
    .filter(Boolean)
    .filter(t => String(t).toLowerCase() !== 'malaria cases in pregnant women')

    if (targets.value.length) {
      const malaria = targets.value.find(t => String(t).toLowerCase() === 'total malaria cases')
      selectedTarget.value = malaria || targets.value[0]
    } else {
      selectedTarget.value = ''
    }

    let y = years.value.length ? years.value[years.value.length-1] : new Date().getFullYear()
    let m = 1
    const latestForTarget = selectedTarget.value ? latestByTarget.value?.[selectedTarget.value] : null
    const latestOverall = data?.latest_dt_reference || null
    const pickYearMonth = (ym) => {
      const [yy, mm] = (ym || '').split('-')
      if (yy && mm) { y = +yy; m = +mm }
    }
    if (latestForTarget) pickYearMonth(latestForTarget)
    else if (latestOverall) pickYearMonth(latestOverall)

    selectedYear.value = y
    const monthsAvail = monthsByYearTarget.value?.[String(y)]?.[selectedTarget.value]
                      || monthsByYear.value?.[String(y)]
                      || []
    selectedMonth.value = monthsAvail.length ? monthsAvail.sort((a,b)=>a-b).slice(-1)[0] : m
  }catch(e){
    error.value = e?.response?.data?.detail || e.message || 'Failed to load available dates'
  }
}

/** ===== Lifecycle ===== */
onMounted(async ()=>{
  await fetchAvailableDates()

  map.value = L.map('map', {
    center:[7.3697,12.3547],
    zoom:6,
    zoomAnimation:true,
    preferCanvas:true,
    updateWhenZooming:false,
    updateWhenIdle:true,
    zoomControl: false
  })

  // Base imagery
  baseTiles = markRaw(
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',{
      maxZoom:19,
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    })
  ).addTo(toRaw(map.value))

  // Labels overlay
  const labelsPane = toRaw(map.value).createPane('labels')
  labelsPane.style.zIndex = '650'
  labelsPane.style.pointerEvents = 'none'
 

  // Logout control
  logoutControl = L.control({ position: 'topright' })
  logoutControl.onAdd = () => {
    const container = L.DomUtil.create('div', 'leaflet-control custom-logout-control')
    const btn = L.DomUtil.create('button', 'btn btn-light icon-btn d-flex leaflet-control-layers', container)
    btn.setAttribute('aria-label', 'Log out')
    btn.style.padding='22px'
    btn.innerHTML = '<i class="fa-solid fa-power-off" style="font-size:20px"></i>'
    L.DomEvent.disableClickPropagation(container)
    L.DomEvent.on(btn, 'click', (e)=>{ e.preventDefault(); logoutAndGo() })
    return container
  }
  logoutControl.addTo(toRaw(map.value))

  //info control
  infoControl = L.control({ position: 'topright' })
  infoControl.onAdd = () => {
    const container = L.DomUtil.create('div', 'leaflet-control custom-logout-control')
    const btn = L.DomUtil.create('button', 'btn btn-light icon-btn d-flex leaflet-control-layers', container)
    btn.setAttribute('aria-label', 'Log out')
    btn.style.padding='22px'
    btn.innerHTML = '<i class="fa-solid fa-chart-line" style="font-size:20px"></i>'
    L.DomEvent.disableClickPropagation(container)
    L.DomEvent.on(btn, 'click', (e)=>{
      e.preventDefault()
      showInfoModal.value = true
      
     })
    return container
  }
  infoControl.addTo(toRaw(map.value))
  // Logos control
  logosControl = L.control({ position: 'topleft' })
  logosControl.onAdd = () => {
    const container = L.DomUtil.create('div', 'leaflet-control custom-logos-control')
    container.innerHTML = `
      <div class="logo-control-bottom shadow">
        <img src="/img/edge.png" style="width:120px;border-radius:8px;margin-right:10px" />
        <img src="/img/BEYOND_LOGO_SOCIAL.png" style="width:80px"   />
        <img src="/img/logos.png" style="width:200px" class="px-1" />
      </div>
    `
    L.DomEvent.disableClickPropagation(container)
    return container
  }
  logosControl.addTo(toRaw(map.value))

  // Coordinates control (bottom-left)
  coordsControl = buildCoordsControl()
  coordsControl.addTo(toRaw(map.value))

  

  
  baseOSM = markRaw(
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19, attribution: '&copy; OpenStreetMap contributors'
    })
  )

  // Overlay groups
  polygonsGroup = markRaw(L.layerGroup())
  boundariesGroup = markRaw(L.layerGroup())
  safeAdd(polygonsGroup)
  safeAdd(boundariesGroup)

  // Layers control
  const baseLayers = { 'Esri Imagery': baseTiles, 'OpenStreetMap': baseOSM }
  const overlays = { 'Predictions': polygonsGroup, 'Boundaries': boundariesGroup }
  layersControl = L.control.layers(baseLayers, overlays, { collapsed: true }).addTo(toRaw(map.value))


  // Measure control (leaflet.measurecontrol) — after leaflet-draw is loaded
  const measureOpts = { position: 'topright' }
  if (L.Control && L.Control.MeasureControl) {
    measureControl = new L.Control.MeasureControl(measureOpts)
  } else if (L.control && typeof L.control.measureControl === 'function') {
    measureControl = L.control.measureControl(measureOpts)
  } else if (L.Control && L.Control.Measure) {
    measureControl = new L.Control.Measure(measureOpts)
  }

  if (measureControl) {
    const m = toRaw(map.value)
    measureControl.addTo(m)
     const el = typeof measureControl.getContainer === 'function'
    ? measureControl.getContainer()
    : null

    if (el) {
      //console.log(el)
      el.classList.add('leaflet-control-draw-measure-2','d-flex', 'align-items-center', 'justify-content-center')

      const a = el.querySelector('a.leaflet-control-draw-measure')
      if (a && !a.querySelector('i')) {
        a.innerHTML = `<i class="fa-solid fa-ruler-horizontal" style="font-size:20px"></i>`
        // ensure proper centering
        a.style.display = 'flex'
        a.style.alignItems = 'center'
        a.style.justifyContent = 'center'
        a.style.textIndent = '0' // in case plugin uses text-indent hacks
        a.setAttribute('aria-label', 'Measure distances')
        a.setAttribute('title', 'Measure distances')
      }
      }
  }

  L.control.scale().addTo(map.value, { position: 'bottomright'})

  // Canvas renderer
  canvasRenderer = L.canvas()

  toRaw(map.value).whenReady(async () => {
    try {
      await loadBoundaries()
      await loadPolygons()
    } catch(e) {
      error.value = e?.message || 'Failed to initialize'
    }
  })
})

onBeforeUnmount(()=>{
  const m = toRaw(map.value)
  if (coordsMoveHandler && m) {
    m.off('mousemove', coordsMoveHandler)
    coordsMoveHandler = null
  }
  if (coordsControl) { coordsControl.remove(); coordsControl = null }
  if (measureControl) { measureControl.remove(); measureControl = null }

  if(map.value){
    safeRemove(polygonsGroup)
    safeRemove(boundariesGroup)
    safeRemove(polygonsLayer)
    
    if (layersControl) { layersControl.remove(); layersControl = null }
  
    if (baseOSM && map.value.hasLayer(baseOSM)) baseOSM.removeFrom(map.value)
    if (baseTiles && map.value.hasLayer(baseTiles)) baseTiles.removeFrom(map.value)
    if (logoutControl) { logoutControl.remove(); logoutControl = null }
    if (logosControl) { logosControl.remove(); logosControl = null }
    if (bigImageControl) { bigImageControl.remove(); bigImageControl = null }
    map.value.remove()
    map.value=null
  }
})

function recolorChartFromLegend(){
  if (!chartInstance || !currentBins.value || !currentPalette.value) return
  const ds = chartInstance.data.datasets?.[0]
  if (!ds) return
  const values = ds.data || []
  ds.backgroundColor = buildBarColors(values, currentBins.value, currentPalette.value, selectedLegendClass.value)
  ds.borderColor = (ds.backgroundColor || []).map(c => c.replace('0.85','1.0').replace('0.95','1.0'))
  chartInstance.update('none')
}

// If legend selection changes elsewhere, recolor chart
watch(selectedLegendClass, () => recolorChartFromLegend())

/** ===== Keep selection valid & reload ===== */
watch(sliderData,(arr)=>{
  if(!arr.length) return
  if(!arr.includes(selectedMonth.value)) selectedMonth.value = arr[arr.length-1]
})
watch([selectedYear, selectedMonth, selectedTarget], ()=>{ loadPolygons() })
watch(gid0, () => updateBoundaryStyles())

</script>

<style>
#map .leaflet-popup-content-wrapper {
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial;
}
.leaflet-interactive { cursor: pointer; }

/* Slider spacing */
.vue-slider { margin: 4px 6px 0; }
.vue-slider-ltr .vue-slider-mark-label,
.vue-slider-rtl .vue-slider-mark-label { margin-top: 4px; }

/* Legend */
.legend-header { display:flex; align-items:center; justify-content:center; gap:8px; margin-bottom:6px; }
.legend-title { font-weight:600; }
.legend-help { position:relative; width:18px; height:18px; line-height:18px; display:inline-flex; align-items:center; justify-content:center; font-weight:700; color:#003252; background:#00cbd5; border-radius:50%; cursor:help; user-select:none; outline:none; }
.legend-help:hover .legend-tooltip, .legend-help:focus .legend-tooltip { opacity:1; visibility:visible; transform:translateY(0); }
.legend-tooltip { position:absolute; right:0; bottom:calc(100% + 8px); background:#fff; color:#172b4d; border:1px solid rgba(0,0,0,.1); border-radius:8px; box-shadow:0 8px 24px rgba(0,0,0,.2); min-width:240px; max-width:320px; z-index:1002; opacity:0; visibility:hidden; transform:translateY(4px); transition:opacity .15s ease, transform .15s ease, visibility .15s; }
.legend-tooltip::after { content:''; position:absolute; right:8px; top:100%; border-width:6px; border-style:solid; border-color:#ffffff transparent transparent transparent; filter: drop-shadow(0 1px 0 rgba(0,0,0,.1)); }
.legend-table { width:100%; border-collapse:collapse; font-size:12px; }
.legend-table th, .legend-table td { padding:4px 6px; border-bottom:1px solid #eee; text-align:left; }
.legend-table thead th { font-weight:700; color:#0b2239; }
.legend-table tbody tr:last-child td { border-bottom:0; }

/* Top-right icon button */
.icon-btn{ width:32px; height:32px; border-radius:50%; padding:0; display:inline-flex; align-items:center; justify-content:center; }

/* Map logout control container */
.custom-logout-control{ background:transparent; border:0; box-shadow:none; }
.custom-logout-control .icon-btn{ box-shadow:0 1px 2px rgba(0,0,0,.15); }
.logo-control-bottom{ background:#ffffff; padding:10px; border-radius:8px; }
.leaflet-control-layers{ background:#003252!important; color:white!important; border-color:white!important; border-radius:8px!important; }

/* Coordinates control styling */
.coords-control{ background:#003252; color:#fff; border-radius:8px; padding:8px 10px; font-size:12px; border:1px solid rgba(255,255,255,.25); }
.coords-inner{ display:flex; flex-direction:column; gap:6px; }
.coords-row{ display:flex; align-items:center; gap:6px; }
.coords-label{ font-weight:600; }
.coords-select{ background:#003252!important; color:#fff!important; border-color:#fff!important; height:28px; padding:2px 6px; border-radius:6px; }
.coords-values{ display:flex; gap:10px; font-variant-numeric: tabular-nums; }
.coords-key{ opacity:.8; margin-right:2px; }

/* Optional: measure control container theming (plugin classes vary) */
.leaflet-control-measurecontrol,
.leaflet-control-measure,
.leaflet-measure-control { border-radius:8px; overflow:hidden; }
.leaflet-control-draw-measure-2 {
  background:#003252 !important;
  color:white !important;
  border-radius:8px !important;
  padding:4px !important;
  border:2px solid white !important;
  cursor: pointer;
}
.leaflet-control-draw-measure {
  background:#00335200 !important;
  color:white !important;

  border-radius:0px !important;
  border:0px solid white !important;
  cursor: pointer;
}
.leaflet-control-draw-measure-2:hover {
  background:#005a7a !important;
}
.leaflet-bar{
  border-radius:8px;
  width: 47px!important;
  height: 47px!important;
}
.chart-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.chart-modal {
  width: min(900px);
  height: min(60vh);
  background: #0b2239;
  color: #fff;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0,0,0,.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chart-modal-info {
  width: min(900px);
  height: 100vh;
  background: #0b2239;
  color: #fff;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0,0,0,.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chart-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .75rem 1rem;
  background: #003252;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.chart-title { font-weight: 600; }

/*.chart-modal canvas {
  width: 100% !important;
  height: 90% !important;
 padding: 20px;
}*/
.map-wrap { position: relative; } /* ensure overlay positions over the map */

.map-loader-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1003; /* above tiles & vectors; below floating panel (z=1001 on panel) */
  pointer-events: none; /* let map not be clickable while loading (or set to auto to block) */
}

.map-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255,255,255,0.35);
  border-top-color: #00cbd5;
  border-radius: 50%;
  animation: mapspin 0.9s linear infinite;
  margin-bottom: 10px;
}

.map-loader-text {
  color: #fff;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0,0,0,.4);
}

@keyframes mapspin {
  to { transform: rotate(360deg); }
}

.chartWrapper {
  position: relative;
  height: 100%;
  
}

/* The fixed (left) axis canvas sits on top, doesn't eat mouse events */
.chartWrapper > canvas {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.chartAreaWrapper {
  width: 100%;               /* visible width; change as you like */
  height: calc(100% - 48px);  /* leaves room for header */
  overflow-x: auto;
  overflow-y: hidden;
  overflow-x: scroll;
  direction: rtl;
}

.svg-container{
  width:810px!important;
  height: 450px!important;

}
.legend-download-link{
  color:#00cbd5;
  font-weight:600;
  text-decoration:none;
  font-size:12px;
}
.legend-download-link:hover{
  color:#ffffff;
  text-decoration:underline;
}

</style>
